// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".borderAvatar[data-v-3487e872]{\n  border-radius: 93.571px;\n  border: 0.468px solid rgba(36, 36, 36, 0.10);\n  background: #FFF;\n  padding: 3.75px 7.5px 3.75px 3.75px;\n}\n.customText[data-v-3487e872]{\n  color: #7A818A;\n  font-size: 14px;\n  font-weight: 400;\n}\n", ""]);
// Exports
module.exports = exports;
